import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const TooltipBox = styled.div`
  background-color: transparent;
  border-radius: 3px;
  color: transparent;
  font-family: inherit;
  font-size: 1rem;
  font-weight: 400;
  padding: 0.7em 0.6rem;
  position: absolute;
  top: calc(100% + 0.5em);
  visibility: hidden;
  z-index: 2;
  &:before {
    border: 2px solid transparent;
    content: "";
    height: 0;
    left: calc(50% - 2px);
    position: absolute;
    top: -2px;
    transform: rotate(135deg);
    width: 0;
  }
  > div {
    overflow: hidden;
  }
`;

const StyledButton = styled.button`
  align-items: center;
  border-color: transparent;
  border-radius: 1rem;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  height: 3.4rem;
  justify-content: center;
  position: relative;
  width: 3.4rem;
  & :hover > ${TooltipBox} {
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 3px;
    color: #fff;
    visibility: visible;
    &:before {
      border-color: transparent transparent rgba(0, 0, 0, 0.8)
        rgba(0, 0, 0, 0.8);
    }
  }
`;

export function BaseButton(props) {
  const { tooltip, children, ...buttonProps } = props;
  return (
    <Container>
      <StyledButton {...buttonProps}>
        {children}
        {!props.disabled && tooltip && <TooltipBox>{tooltip}</TooltipBox>}
      </StyledButton>
    </Container>
  );
}
